module.exports = __webpack_public_path__ + "img/lost vape.0ff9eadc.png";